import React from 'react'
import Svg from './Svg'
import { height, width } from '@fortawesome/free-solid-svg-icons/fa0'
export default function Table({table1, table2, colorMap, show}) {
    if(show =="both"){

        return (
        <>
        <div>
            <h2>Table 1</h2>
            {
          table1?.map((row, rowIndex) => {

            if(row.Name==" "){
                return <div
                style={{
                    height: '300px',
                    width: '300px',
                    border:"10px solid black"
                }
                }
                >

                </div>
            }
            return (<div
            style={{
                height: '300px',
                width: '300px',

                border:"10px solid black"
            }
            }
            >
            <Svg drawing={row.Name} Color={colorMap[row.Color]} />
            </div>)
          })
        }
          </div>
          <div>
          <h2>Table 2</h2>
            {
          table2?.map((row, rowIndex) => {

            if(row.Name==" "){
                return <div
                style={{
                    height: '300px',
                    width: '300px',
                    border:"10px solid black",
                    marginRigth:"10px"
                }
                }
                >

                </div>
            }
            return (<div
            style={{
                height: '300px',
                width: '300px',

                border:"10px solid black"
            }
            }
            >
            <Svg drawing={row.Name} Color={colorMap[row.Color]} />
            </div>)
          })
        }
          </div>
          </>)
    }
    const staticRows = show === 't1' ? table1 : table2;
  return (
  <div>
    <h1>{show=='t1'?"Table 1":"Table 2"}</h1>
    {
  staticRows?.map((row, rowIndex) => {

    if(row.Name==" "){
        return <div
        style={{
            height: '300px',
            width: '300px',
            border:"10px solid black"
        }
        }
        >

        </div>
    }
    return (<div
    style={{
        height: '300px',
        width: '300px',

        border:"10px solid black"
    }
    }
    >
    <Svg drawing={row.Name} Color={colorMap[row.Color]} />
    </div>)
  })
}
  </div>
  )



}
